<span *ngIf="toggleContent">
<app-payments *ngIf="!doNotShow"></app-payments>
<app-cookies></app-cookies>
<div class="footer-row">
    <div class="bs-row d-flex d-sm-block footer-container m-auto">
        <div class="col-12 container">
<!--            <h4>{{ 'static.footerHeader' | translate }}</h4>-->
            <div class="bs-row container content d-flex flex-row-reverse m-auto px-0">
                <div class="footer-links-block col-6 col-sm-3 fl ps-5">
                    <a [routerLink]="[showLang, 'contact-us']">{{ 'menu.contactJinniLotto' | translate }}</a>
                    <a [routerLink]="[showLang, 'privacy-policy']">{{ 'menu.privacyNotice' | translate }}</a>
                    <a [routerLink]="[showLang, 'safety-security']">{{ 'menu.safetyAndSecurity' | translate }}</a>
                    <a [routerLink]="[showLang, 'terms-conditions']">{{ 'menu.termsConditions' | translate }}</a>
                    <a [routerLink]="[showLang, 'responsible-gaming-policy']" class="mobile-show">{{ 'menu.responsibleGamingPolicy' | translate }}</a>
                    <!--<a routerLink="/bonus-terms" class="mobile-show">{{ 'menu.bonusTerms' | translate }}</a>-->
                </div>
                <div class="footer-links-block col-6 col-sm-3 fl">
                    <a [routerLink]="[showLang, 'responsible-gaming-policy']" class="mobile-hide">{{ 'menu.responsibleGamingPolicy' | translate }}</a>
                    <!--<a routerLink="/bonus-terms" class="mobile-hide">{{ 'menu.bonusTerms' | translate }}</a>-->
                    <a [routerLink]="[showLang, 'game-rules']">{{ 'menu.gameRules' | translate }}</a>
                    <a [routerLink]="[showLang, 'bonus-policy']">{{ 'menu.bonuspolicy' | translate }}</a>
                    <a [routerLink]="[showLang, 'faq']">{{ 'menu.faq' | translate }}</a>
                    <a [routerLink]="[showLang, 'about-us']" class="mobile-show">{{ 'menu.aboutUs' | translate }}</a>
                    <a [routerLink]="[showLang, 'lotteries-results']" class="mobile-show">{{ 'menu.results' | translate }}</a>
                    <a [routerLink]="[showLang, 'contact-us']" class="mobile-show">{{ 'menu.affiliateProgram' | translate }}</a>
                </div>
                <div class="footer-links-block col-sm-3 fl mobile-hide">
                    <a [routerLink]="[showLang, 'about-us']" class="mobile-hide">{{ 'menu.aboutUs' | translate }}</a>
                    <a [routerLink]="[showLang, 'lotteries-results']" class="mobile-hide">{{ 'menu.results' | translate }}</a>
                    <a [routerLink]="[showLang, 'contact-us']" class="mobile-hide">{{ 'menu.affiliateProgram' | translate }}</a>
                </div>
                <div class="col-12 col-sm-3 d-flex align-items-center justify-content-center fl py-4 py-sm-0">
                    <img src="../../../assets/images/footer/troll_tech_logo.png" class="h-auto">
                </div>
            </div>
        </div>
        <div class="col-12 row">
            <div class="container xl-12 md-12 sm-12 xs-12 px-0">
                <hr/>
                <div class="logo-footer d-none text-center">
                    <img src="../../../assets/images/footer/troll_tech_logo.png">
                </div>
                <div class="footer-text">
                    {{ 'static.footer' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
    <div *ngIf="showSuccessPaymentMethod" id="paymentAddedWithSuccess"><img class="check-it" src="../../../assets/images/icons/icon/check.svg"> {{'successPaymentMethodAdd.success' | translate}}</div>
</span>
